import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { Product_Type } from '../models/product_Type';

@Injectable()
export class ProductTypeService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }
  
  public getAll(): Promise<Product_Type[]> {
    const headers = {
      'Content-Type': 'application/json',
    };
    return new Promise((resolve, reject) => {
      this.http.get<Product_Type[]>(environment.apiUrl + 'producttype/getall', { headers: headers }).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

}
